export default __webpack_public_path__ + "static/media/Dislike_Selected.7d5625fa.svg";